import { HSLColor } from '@yola/yola-palette-generator';
import border from '../../border';

const dark = (params) => {
  const { hue, saturation, lightness } = border.default.dark(params);

  return new HSLColor(hue, saturation, lightness, 0);
};

export default dark;
